import { createBrowserClient } from "@supabase/ssr"
import * as z from "zod"

import { safelyExtractEnvVar } from "@repo/utils"
import type { Database } from "../database.types"

const configSchema = z.object({
  SUPABASE_URL: z.string().min(1, { error: "SUPABASE_URL is required" }),
  SUPABASE_PUBLIC_KEY: z
    .string()
    .min(1, { error: "SUPABASE_PUBLIC_KEY is required" }),
})

export function getSupabaseBrowserClient() {
  const config = configSchema.parse({
    SUPABASE_URL: safelyExtractEnvVar(["VITE_SUPABASE_URL", "SUPABASE_URL"]),
    SUPABASE_PUBLIC_KEY: safelyExtractEnvVar([
      "VITE_SUPABASE_PUBLIC_KEY",
      "SUPABASE_PUBLIC_KEY",
      // Legacy keys
      "VITE_SUPABASE_ANON_KEY",
      "SUPABASE_ANON_KEY",
    ]),
  })

  return createBrowserClient<Database>(
    config.SUPABASE_URL,
    config.SUPABASE_PUBLIC_KEY,
  )
}
